if (!customElements.get('shepherd-mobile-purchase-v2')) {
  customElements.define('shepherd-mobile-purchase-v2', class extends HTMLElement {
    connectedCallback() {
      this.section = document.getElementById(this.dataset.sectionId);
      this.bar = this.querySelector('.shepherd-mobile-purchase-bar');
      this.button = this.querySelector('[data-shepherd-sticky-button]');
      this.price = this.querySelector('[data-shepherd-sticky-price]');
      if (!this.section || !this.bar || !this.button || !this.price) return;
      this.mobile = window.matchMedia('(max-width: 600px)');
      this.lockUntil = 0;
      this.abort = new AbortController();
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.refresh();
        });
      };
      this.resize = () => {
        this.section.querySelectorAll('.shepherd-product-details').forEach(details => {
          details.open = !this.mobile.matches;
        });
        this.schedule();
      };
      this.forward = () => {
        this.refresh();
        const original = this.getOriginal();
        if (!original || this.button.disabled) return;
        const form = original.form;
        if (form && !form.reportValidity()) {
          const invalid = form.querySelector(':invalid');
          if (invalid) invalid.scrollIntoView({block: 'center'});
          return;
        }
        this.lockUntil = Date.now() + 1800;
        this.button.disabled = true;
        original.click();
        clearTimeout(this.releaseTimer);
        this.releaseTimer = setTimeout(this.schedule, 1850);
      };
      const opts = {signal: this.abort.signal};
      this.button.addEventListener('click', this.forward, opts);
      window.addEventListener('scroll', this.schedule, {...opts, passive: true});
      window.addEventListener('resize', this.schedule, opts);
      window.addEventListener('pageshow', this.schedule, opts);
      this.mobile.addEventListener('change', this.resize, opts);
      this.section.addEventListener('change', this.schedule, opts);
      this.section.addEventListener('product-variant-switch', this.schedule, opts);
      this.section.addEventListener('click', event => {
        if (event.target.closest('[data-atc]') === this.getOriginal()) {
          this.lockUntil = Date.now() + 1800;
          clearTimeout(this.releaseTimer);
          this.releaseTimer = setTimeout(this.schedule, 1850);
          this.schedule();
        }
      }, {...opts, capture: true});
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.section, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'aria-busy', 'class', 'value', 'data-atc']
      });
      if (window.ResizeObserver) {
        this.sizeObserver = new ResizeObserver(this.schedule);
        this.sizeObserver.observe(this.section);
      }
      this.dataset.ready = '';
      this.resize();
    }
    getOriginal() {
      return this.section.querySelector('.purchase-section button[data-atc]');
    }
    refresh() {
      const original = this.getOriginal();
      const state = this.section.querySelector('[data-shepherd-purchase-state]');
      const renderedPrice = this.section.querySelector('.product-details-price [data-variant-price]');
      const form = original && original.form;
      const selected = form && form.querySelector('[name="id"]');
      const rect = original && original.getBoundingClientRect();
      const visible = this.mobile.matches && rect && rect.width > 0 && rect.height > 0 && rect.bottom < 0;
      this.bar.hidden = !visible;
      if (!original || !state || !selected || !renderedPrice) {
        this.button.disabled = true;
        return;
      }
      const price = renderedPrice.textContent.trim();
      const label = original.textContent.trim();
      if (this.price.textContent !== price) this.price.textContent = price;
      if (this.button.textContent !== label) this.button.textContent = label;
      const unavailable = state.dataset.available !== 'true' || state.dataset.variantId !== selected.value;
      const busy = original.disabled || original.getAttribute('aria-disabled') === 'true' ||
        original.getAttribute('aria-busy') === 'true' || original.classList.contains('disabled') ||
        original.classList.contains('loading') || form.classList.contains('disabled');
      this.button.disabled = unavailable || busy || Date.now() < this.lockUntil;
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.sizeObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
      clearTimeout(this.releaseTimer);
    }
  });
}
